import { IconProps } from 'types/icon.type'

export const ArrowRightIcon = (props: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Arrow right icon</title>
      <mask
        id="mask0_3_1122"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="21"
      >
        <rect
          x="0.654297"
          y="0.610413"
          width="19.487"
          height="19.487"
          fill={props.color}
          stroke="white"
        />
      </mask>
      <g>
        <path
          d="M7.01538 2.25714C7.26763 2.25717 7.49019 2.3376 7.68335 2.49933L7.7644 2.57355L14.3152 9.14581V9.14679C14.4425 9.27407 14.5463 9.41275 14.6257 9.56378L14.697 9.71808C14.7818 9.9301 14.824 10.1421 14.824 10.3538C14.824 10.5126 14.8004 10.6715 14.7527 10.8304L14.697 10.9896C14.6335 11.1484 14.5456 11.2949 14.4343 11.43L14.3152 11.5618L7.74292 18.1341C7.53177 18.3452 7.28553 18.4468 7.00464 18.4398C6.75884 18.4336 6.53977 18.3501 6.34741 18.1878L6.26636 18.1126C6.05546 17.9016 5.95002 17.6525 5.94995 17.3646C5.94995 17.1124 6.03059 16.8897 6.19214 16.6966L6.26636 16.6155L12.5281 10.3538L6.24487 4.07062C6.03401 3.85962 5.93222 3.6105 5.93921 3.32257L5.94702 3.21613C5.9714 3.00721 6.05296 2.82017 6.19214 2.6546L6.26636 2.57355C6.47751 2.36239 6.72717 2.25714 7.01538 2.25714Z"
          fill={props.color}
          stroke="white"
          strokeWidth="0.025"
        />
      </g>
    </svg>
  )
}
